document.addEventListener('DOMContentLoaded', () => {

  const menuToggle = document.getElementById('btnToggleMenu')
  const menuWrapper = document.getElementById('menu')
  if(menuToggle && menuWrapper) {
    const menuBack = document.querySelector('#menu .menu__bg')
    const menuBlock = document.querySelector('#menu .menu__block')
    const menuBtn = document.querySelector('#menu .menu__btn')
    const menuItemsMain = document.querySelector('#menu .menu__items_main')
    const menuItemsWrapper = document.querySelector('#menu .menu__items-wrapper')
    const menuName = document.querySelector('#menu .menu__name')
    
    menuBack.addEventListener('click', () => {
      menuToggle.classList.toggle('on')
      menuBack.classList.toggle('on')
      menuBlock.classList.toggle('on')
      setTimeout(() => {
        menuWrapper.classList.toggle('on')
      }, 150)
    })

    menuBtn.addEventListener('click', () => {
      if (menuItemsMain.classList.contains('on')) {
        menuToggle.classList.toggle('on')
        menuBack.classList.toggle('on')
        menuBlock.classList.toggle('on')
        setTimeout(() => {
          menuWrapper.classList.toggle('on')
        }, 150)
      } else {
        const sub = menuWrapper.querySelector('#menu .menu__items_sub.on')
        menuName.innerHTML = menuNameDefault
        sub.classList.toggle('on')
        menuItemsMain.classList.toggle('on')
      }
    })

    menuToggle.addEventListener('click', () => {
      menuToggle.classList.toggle('on')
      menuWrapper.classList.toggle('on')
      setTimeout(() => {
        menuBack.classList.toggle('on')
        menuBlock.classList.toggle('on')
      }, 150)
    })
    menuJson = JSON.parse(menu)
    menuJson.forEach(element => {
      const block = document.createElement('div')
      block.classList.add('menu__item')

      const link = document.createElement('a')
      link.innerHTML = element.name
      link.setAttribute('href', menuSlug 
        ? '/' + menuSlug + element.url 
        : element.url
      )
      link.classList.add('menu__link')
      block.appendChild(link)

      if(element.menu && element.menu.length > 0) {
        const sub = document.createElement('button')
        sub.classList.add('menu__sub')
        const icon = document.createElement('i') 
        icon.classList.add('icon-next')
        sub.appendChild(icon)
        block.appendChild(sub)

        const itemsBlock = document.createElement('div')
        itemsBlock.classList.add('menu__items', 'menu__items_sub')
        itemsBlock.setAttribute('block-target', element.target)
        element.menu.forEach(item => {
          const link = document.createElement('a')
          link.innerHTML = item.name
          link.setAttribute('href', menuSlug 
          ? '/' + menuSlug + item.url 
          : item.url)
          link.classList.add('menu__sub-link')
          itemsBlock.appendChild(link)
        })
        menuItemsWrapper.appendChild(itemsBlock)

        sub.addEventListener('click', () => {
          menuName.innerHTML = element.name
          itemsBlock.classList.toggle('on')
          menuItemsMain.classList.toggle('on')
        })
      }
      menuItemsMain.appendChild(block)
    })

    if (menuTargetDefault && menuTargetDefault != 'main') {
      
      const menus = menuWrapper.querySelectorAll('div[block-target]')
      menus.forEach(menu => {
        if (menu.getAttribute('block-target') === menuTargetDefault) {
          menu.classList.toggle('on')
          menuItemsMain.classList.toggle('on')
          const target = menuJson.find(item => item.target === menuTargetDefault)
          menuName.innerHTML = target.name
        }
      })
      
    }
  }

})